import configFromParams from './params'
const config = configFromParams()

// Check the validity of page id; lifted from Legacy LC
export function isValidPageId (pageId) {
  // some LaunchPad environments cannot provide ebook content
  if (config.disableEbook) {
    return false
  }
  // If id is null or length < 5, then it is invalid.
  if (pageId == null || pageId.length < 5) {
    return false
  }
  // remove quote in the pageId
  pageId = pageId.replace(/"/g, '')
  // If id has space, or colon, then it is invalid.
  if (pageId.indexOf(' ') !== -1 || pageId.indexOf(':') !== -1) {
    return false
  }
  // If id is combined form like {bookid}_{pageId} and bookid is empty then it is invalid.
  // Note that pageId can itself contain underscores
  const bookIdPageId = pageId.split('_', 1)
  if (bookIdPageId.length === 1 && bookIdPageId[0] === '') {
    return false
  }
  return true
}
